import { render, staticRenderFns } from "./WritingTask2.vue?vue&type=template&id=c312c17e&scoped=true&"
import script from "./WritingTask2.vue?vue&type=script&lang=ts&"
export * from "./WritingTask2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c312c17e",
  null
  
)

export default component.exports